<div class="d-flex align-items-center gap-1">
    <input type="text" [(ngModel)]="text">
</div>

